$(document).ready(() => {
    const chart = $('#chart-container');
    const etcName = $(chart).data('etc-name');
    const cryptName = $(chart).data('crypt-name');
    const etcNameTooltip = $(chart).data('etc-tooltip');
    const cryptNameTooltip = $(chart).data('crypt-tooltip');
    const namex1NameTooltip = $(chart).data('namex1-name');

    const title = $(chart).data('title');
    const subtitle = $(chart).data('subtitle');
    const jsonFile = $(chart).data('file-name');
    const after = $(chart).data('after');
    var jsonName = `/chart-json/${jsonFile}.json?rnd=${dateNum}`;


    if (!etcName) {
        return;
    }

    const isFactSheet = /fact-sheet/i.test(window.location.pathname);
    const isDA20 = /bitwise-msci-digital-assets-select-20-etp/i.test(window.location.pathname);

    if (isFactSheet) Chart.defaults.font.size = 7;
    if (isDA20) jsonName = `/products/bitwise-msci-digital-assets-select-20-etp/${jsonFile}.json?rnd=${dateNum}`;

    $.ajax({
        url: jsonName,
        dataType: 'json',
    }).done(result => {
        const data = {
            labels: result.data.map(
                p => p.x
            ),
            datasets: [
                {
                    xLabel: cryptNameTooltip,
                    label: cryptName,
                    borderColor: result.comparative_line_color ? result.comparative_line_color: '#1226AA',
                    backgroundColor: result.comparative_line_color ? result.comparative_line_color: '#1226AA',
                    borderWidth: 1,
                    pointRadius: 0,
                    tension: 0.4,
                    data: result.data.map(p => {
                        return p.y
                    }),
                },
                {
                    xLabel: etcNameTooltip,
                    label: etcName,
                    borderColor: result.line_color,
                    backgroundColor: result.line_color,
                    borderWidth: 1,
                    pointRadius: 0,
                    tension: 0.4,
                    data: result.data.map(p => {
                        return p.z
                    }),
                }
            ]
        };

        if(typeof result.data[0].y2 !== 'undefined') {
            data.datasets.push(
                {
                    xLabel: namex1NameTooltip,
                    label: namex1NameTooltip,
                    borderColor: result.comparative_line_color2 ? result.comparative_line_color2: '#1226AA',
                    backgroundColor: result.comparative_line_color2 ? result.comparative_line_color2: '#1226AA',
                    borderWidth: 1,
                    pointRadius: 0,
                    tension: 0.4,
                    data: result.data.map(p => {
                        return p.y2
                    }),
                }
            )
        }

        const chart = new Chart(
            document.getElementById('chart'),
            {
                type: 'line',
                data: data,
                options: {
                    maintainAspectRatio: false,
                    responsive: true,
                    devicePixelRatio: 2,
                    interaction: {
                        intersect: false,
                        mode: 'index',
                        axis: 'x'
                    },
                    tooltips: {
                        mode: 'label'
                    },
                    scales: {
                        x: {
                            type: 'time',
                            title: {
                                display: false,
                                text: 'Date'
                            },
                            ticks: {
                                autoSkip: true,
                                maxRotation: 0,
                                padding: isFactSheet ? 0 : 15,
                                maxTicksLimit: 12
                            },
                            grid: {
                                display: false,
                            },
                        },
                        y: {
                            title: {
                                display: false,
                                text: '%'
                            }
                        }
                    },
                    plugins: {
                        tooltipLine: {
                            consoleText: 'bingo'
                        },
                        tooltip: {
                            callbacks: {
                                title: c => {
                                    return c[0].label.split(/, /).slice(0, 2).join(', ')
                                },
                                label: c => {
                                    return c.dataset.xLabel + ' ' + Number(c.raw).toFixed(2) + after
                                },
                                labelPointStyle : () => ({
                                    pointStyle: 'rectRounded',
                                })
                            },
                            font: {
                                family:"'PPNeue Montreal', sans-serif"
                            },
                            backgroundColor: '#E6E8EB',
                            bodyColor: '#3d3d3e',
                            titleColor: '#3d3d3e',
                            usePointStyle: true,
                            pointStyle: 'rectRounded',
                        },
                        legend: {
                            position: 'top',
                            align: 'end',
                            labels : {
                                boxWidth: 10,
                                padding: 20,
                                usePointStyle: true,
                                pointStyle: 'rectRounded',
                            }
                        },
                        subtitle: {
                            fullSize: false,
                            display: false,
                            text: subtitle,
                            color: '#000',
                            padding: {
                                top: -33,
                            },
                            font : {
                                size: '18px',
                                family:"'PPNeue Montreal', sans-serif",
                            }
                        },
                        title: {
                            fullSize: false,
                            display: false,
                            align:'start',
                            text: title,
                            color: '#3e3e3e',
                            font : {
                                size: '32px',
                                weight: 'normal',
                                family:"'PPNeue Montreal', sans-serif",
                            }
                        }
                }
                },
                plugins: [{
                    id: 'tooltipLine',
                    beforeDraw: chart=>{
                        if(chart.tooltip && chart.tooltip._active && chart.tooltip._active.length) {
                            const ctx = chart.ctx;
                            ctx.save();
                            const activePoint = chart.tooltip._active[0];
                            ctx.beginPath();
                            ctx.setLineDash([8,4]);
                            ctx.moveTo(activePoint.element.x,chart.chartArea.top);
                            ctx.lineTo(activePoint.element.x,chart.chartArea.bottom)
                            ctx.lineWidth = 2;
                            ctx.strokeStyle = '#9ddeca';
                            ctx.stroke();
                            ctx.restore();
                        }
                    }
                }]
            }
        );
    });

    
});